import { Component } from '@angular/core';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer){
    this.matIconRegistry.addSvgIcon(
      'chevron_right',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/chevron_right.svg')
    )
    this.matIconRegistry.addSvgIcon(
      'expand_more',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/expand_more.svg')
    )
    this.matIconRegistry.addSvgIcon(
      'close',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/close-black-48dp.svg')
    )
  }
  title = 'form-generation';
}
